__turbopack_context__.v({
  "align-bottom": "styles-module-scss-module__zoltMq__align-bottom",
  "align-center": "styles-module-scss-module__zoltMq__align-center",
  "align-top": "styles-module-scss-module__zoltMq__align-top",
  "imageContainer": "styles-module-scss-module__zoltMq__imageContainer",
  "promoCard": "styles-module-scss-module__zoltMq__promoCard",
});
